export default "__VITE_ASSET__ded05daf__"